module.exports = __webpack_public_path__ + "img/H-45-ST-1000-N.8ade9fa2.png";